import { get, post } from '@/utils/httpHelper';

module.exports = {
  async findAllVendorInfo () {
    const url = `/esg/security/vendor/findAll`;
    const body = await get(url);
    return body.data;
  },
  async saveVendorInfo (params) {
    const url = `/esg/security/vendor/saveVendor`;
    const body = await post(url, params);
    return body.data;
  },
  async findVendorInfoByConditions (params) {
    const url = '/esg/security/vendor/findByConditions';
    const body = await get(url, params);
    return body.data;
  }
};



// WEBPACK FOOTER //
// ./src/repositories/vendor.repository.js